import { ObservationInstance } from '../types/ObservationTypes';

const displayActivity = (obs: ObservationInstance) => {
  if (obs.activity.indexOf('Other') > -1) {
    if (obs?.other_activity?.length ?? 0 > 0) {
      const activitiesWithoutOther = obs.activity.filter((a) => a !== 'Other');
      return `${activitiesWithoutOther.join(', ')}, Other: ${obs.other_activity}`;
    } else {
      return obs.activity.join(', ');
    }
  } else {
    if (obs?.activity?.length > 1) {
      return obs.activity.join(', ');
    } else {
      return obs.activity.toString();
    }
  }
};

export { displayActivity };
